import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    name: "Name:",
    namePlaceholder: "Name",
    company: "Company:",
    companyPlaceholder: "Company",
    email: "Email:",
    emailPlaceholder: "Email",
    submit: "Submit",
  },
  ja: {
    name: "名前:",
    namePlaceholder: "名前",
    company: "会社名:",
    companyPlaceholder: "会社名",
    email: "メール:",
    emailPlaceholder: "メール",
    submit: "送信",
  },
  es: {
    name: "Nombre:",
    namePlaceholder: "Nombre",
    company: "Empresa:",
    companyPlaceholder: "Empresa",
    email: "Correo electrónico:",
    emailPlaceholder: "Correo electrónico",
    submit: "Enviar",
  },
});

class InputMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      company: "",
      email: "",
      clicked: false,
    };
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleButtonClick = () => {
    const { name, company, email } = this.state;

    if (name.trim() !== "" && company.trim() !== "" && email.trim() !== "") {
      this.setState({ triggerValue: "not_login_3", clicked: true }, () => {
        this.props.triggerNextStep({
          value: {
            name: this.state.name,
            company: this.state.company,
            email: this.state.email,
          },
          trigger: "not_login_3",
        });
      });
    } else {
      // console.log("Please fill in all fields before submitting.");
    }
  };

  render() {
    const containerStyle = {
      padding: "3px",
      width: "445px",
    };

    const inputStyle = {
      width: "215px",
      color: "black",
      borderRadius: "10px",
      padding: "10px",
      border: "1px solid #ccc",
    };

    const buttonStyle = {
      width: "215px",
      height: "40px",
      marginTop: "20px",
      marginBottom: "5px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 0",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { clicked } = this.state;

    return (
      <div style={containerStyle}>
        <label htmlFor="Name">{localizationStrings.name}</label>
        <br />
        <input
          type="text"
          id="Name"
          name="name"
          value={this.state.name}
          style={inputStyle}
          onChange={this.handleInputChange}
          disabled={clicked}
          placeholder={localizationStrings.namePlaceholder}
        />
        <br />
        <label style={{ marginTop: "12px" }} htmlFor="Company">
          {localizationStrings.company}
        </label>
        <br />
        <input
          type="text"
          id="Company"
          name="company"
          value={this.state.company}
          style={inputStyle}
          onChange={this.handleInputChange}
          disabled={clicked}
          placeholder={localizationStrings.companyPlaceholder}
        />
        <br />
        <label style={{ marginTop: "12px" }} htmlFor="email">
          {localizationStrings.email}
        </label>
        <br />
        <input
          type="text"
          id="email"
          name="email"
          value={this.state.email}
          style={inputStyle}
          onChange={this.handleInputChange}
          disabled={clicked}
          placeholder={localizationStrings.emailPlaceholder}
        />
        <br />
        <button
          style={{
            ...buttonStyle,
            ...(clicked && buttonHoverStyle),
            ...(this.state.triggerValue === "4"),
          }}
          onMouseEnter={() => this.setState({ isButtonHovered: true })}
          onMouseLeave={() => this.setState({ isButtonHovered: false })}
          onClick={this.handleButtonClick}
          disabled={
            clicked ||
            !(
              this.state.name.trim() !== "" &&
              this.state.company.trim() !== "" &&
              this.state.email.trim() !== ""
            )
          }
        >
          {localizationStrings.submit}
        </button>
      </div>
    );
  }
}

export default InputMessage;
